// Pure helpers for spaces user presence — avatar color derivation shared between
// ParticipantPanel and TLDraw userInfo so cursors match panel avatars.

// Minimal tldraw camera shape (page-space x/y + zoom z, all required). We use
// it instead of tldraw's VecModel (z is optional there) and TLCamera (which is
// a record with id/typeName/meta — too heavy for ctrl-channel messages and
// in-memory maps). Match this if you want interop with tldraw helpers.
export type TldrawCameraVector = { x: number; y: number; z: number };
//
// IMPORTANT: derive color from the user's stable identity (userId), NOT the
// display name. Display names are sourced from two different paths — the
// /participants API on one side and useAuthStore on the other — and they can
// disagree (e.g. "Ali S1" vs "Ali Se" for the same user). Hashing identity
// guarantees the panel avatar and the canvas cursor pick the same swatch.

const AVATAR_COLORS: { bg: string; text: string }[] = [
  { bg: "#dbeafe", text: "#1d4ed8" },
  { bg: "#fce7f3", text: "#be185d" },
  { bg: "#d1fae5", text: "#065f46" },
  { bg: "#fef3c7", text: "#92400e" },
  { bg: "#ede9fe", text: "#5b21b6" },
  { bg: "#fee2e2", text: "#b91c1c" },
  { bg: "#ffedd5", text: "#c2410c" },
  { bg: "#e0f2fe", text: "#0369a1" },
];

function hashString(input: string): number {
  let hash = 0;
  for (let i = 0; i < input.length; i++)
    hash = (hash * 31 + input.charCodeAt(i)) & 0xffffffff;
  return Math.abs(hash);
}

export function getAvatarColor(seed: string | number | null | undefined): {
  bg: string;
  text: string;
} {
  const key = seed === null || seed === undefined ? "" : String(seed);
  return AVATAR_COLORS[hashString(key) % AVATAR_COLORS.length];
}
